import { useContext, useState } from "react";
import { AppStateContext } from "../../context/AppContext";
import { Button, Space } from "antd";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import EmailUpdate from "./EmailUpdate";
import moment from "moment";
import { useNavigate } from "react-router";
import CustomTable from "../../components/CustomTable";
import useFilter from "../../hooks/useFilter";
import StatusChange from "../../components/StatusChange";
import {
  ListEmail,
  StatusChangeCategory,
  StatusChangeEmail,
} from "../../constants/API/API";
import useApi from "../../hooks/useApi";
import usePermissions from "../../hooks/usePermissions";
import { permissionKeys } from "../../constants/staffRole";

function EmailList() {
  const { setPageHeading } = useContext(AppStateContext);
  const [filters, setFilters] = useFilter({
    sortField: "createdAt",
    sort: "desc",
  });

  setPageHeading("Email Template");
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(new Date().getTime());
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalDocs, setTotalDocs] = useState(0);
  const [visible, setVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const { isEdit, isView } = usePermissions({
    key: permissionKeys.EmailTemplate,
    redirectPermissions: ["isView"],
  });

  useApi({
    callback: ListEmail,
    payload: filters,
    dependencies: [refresh, filters],
    shouldCallApi: true,
    onSuccess: ({ list, totalDocs }) => {
      setData(list);
      setTotalDocs(totalDocs);
      setLoading(false);
    },
    onError: () => {
      setLoading(false);
    },
  });

  const handleEditClick = (record) => {
    setSelectedEmail(record);
    setEditVisible(true);
  };
  const handleViewClick = ({ _id }) => {
    navigate(`/email-view/${_id}`);
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Subject",
      dataIndex: "subject",
      key: "subject",
    },
    {
      title: "Registration Date",
      dataIndex: "registrationDate",
      key: "registrationDate",
      render: (text) => moment(text).format("ll"),
    },

    {
      title: "Status",
      key: "isActive",

      render: (_, { isActive, _id }) => (
        <StatusChange
          _id={_id}
          isActive={isActive}
          callback={StatusChangeEmail}
          setRefresh={setRefresh}
          trigger={isEdit}
        />
      ),
    },

    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <Space size="middle">
          {isEdit && (
            <Button
              type="primary"
              onClick={() => handleEditClick(record)}
              icon={<EditOutlined />}
              title="Edit"
            />
          )}
          {isView && (
            <Button
              type="primary"
              onClick={() => handleViewClick(record)}
              icon={<EyeOutlined />}
              title="View"
            />
          )}
        </Space>
      ),
    },
  ];

  return (
    <>
      <CustomTable
        addFn={false}
        data={data}
        loading={loading}
        filters={filters}
        setFilters={setFilters}
        columns={columns}
        totalDocs={totalDocs}
        searchField={["name"]}
        searchPlaceholder={"Search by Title"}
        fields={{ range: false, search: false }}
      />
      <EmailUpdate
        editVisible={editVisible}
        setEditVisible={setEditVisible}
        selectedEmail={selectedEmail}
        refresh={setRefresh}
      />
    </>
  );
}

export default EmailList;
